/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  deleteSalariesItems,
  getSalariesItemsList,
} from "../../../../apis/salary/salary-items";
import { ControlTable } from "../../../../components/Table";
import useForm from "../../../../hooks/useForm";
import { getParams } from "../../../../utils/params";
import systemAlert from "../../../../utils/systemAlert";
import Payment from "./Payment";

const PaymentList = ({ mode, setMode, detailOpen, setDetailOpen, permission }) => {
  const [fields] = useState([
    { title: "항목명", key: "name" },
    { title: "항목 코드", key: "code" },
    {
      title: "사용 여부",
      key: "isActive",
      onValue: (value) => {
        return value ? "사용" : "미사용";
      },
    },
  ]);
  const [formData, setFormData] = useState({});
  
  const {
    form,
    setSubmit,
    handleSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);
  
  const submit = (params) => {
    setIsLoading(true);
    getSalariesItemsList({
      search: { type: "allowance" },
      ...getParams(params),
    })
      .then((res) => {
        setIsLoading(false);
        setList(res.data.works);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        isHide: (data) => {
          return data.isPublic
        },
        action: (data) => {
          systemAlert('해당 급여내역을 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '승인',
                onClick: () => {
                  setIsLoading(true);
                  deleteSalariesItems(data.idx)
                    .then(() => {
                      submit();
                    })
                    .catch((err) => console.log(err.response))
                    .finally(() => {
                      setIsLoading(false);
                    });
                }
              }
            ]
          })
        },
      },
      {
        label: "수정",
        type: "edit",
        isHide: (data) => {
          return data.isPublic
        },
        action: (data) => {
          setFormData(data);
          setDetailOpen(true);
          setMode("modify");
        },
      },
    ],
  };

  const handleRowClick = (data, e) => {
    const tagName = e.target.tagName
    if(!(tagName=== "TR" || tagName === "TD")) return

    setFormData(data);
    setDetailOpen(true);
    setMode("view");
  }
  
  return (
    <>
      <ControlTable
        isLoading={isLoading}
        list={list}
        fields={fields}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
        onSelect={handleRowClick}
        submit={handleSubmit}
      />
      <Payment
        list={formData}
        mode={mode}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={() => submit(form)}
      />
    </>
  );
};

export default PaymentList;
